const config = {
	BASE_API_URL:
		process.env.REACT_APP_BASE_API_URL || 'http://localhost:4000/v1',
	BASE_DEV_API_URL:
		process.env.REACT_APP_BASE_DEV_API_URL || 'http://localhost:4000/v1',
	BASE_URL: process.env.REACT_APP_BASE_URL || 'http://localhost:3000',
};

export default config;
